import React from 'react';
import Switch from '@material-ui/core/Switch';

export const RenderSwitchField = ({input, value, meta: {touched, error}, ...custom}) => (
  <Switch
    {...input}
    {...custom}
    value={value}
  />
)